import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { saveLanguage } from "./i18n";
import "./i18n";

interface LanguageSwitcherProps {
  fromMenu: boolean;
}

function LanguageSwitcher({ fromMenu }: LanguageSwitcherProps) {
  const { t, i18n } = useTranslation();
  const [currentLang, setCurrentLang] = useState<"ko" | "en">("ko");

  // 현재 언어 상태 동기화
  useEffect(() => {
    setCurrentLang(i18n.language as "ko" | "en");
  }, [i18n.language]);

  const handleChangeLanguage = () => {
    const targetLang = currentLang === "en" ? "ko" : "en";
    setCurrentLang(targetLang);
    i18n.changeLanguage(targetLang);
    saveLanguage(targetLang); // 로컬 스토리지에 저장
  };

  return (
    <div
      className="flex cursor-pointer items-center text-white px-2 rounded transform transition-all duration-300 ease-in-out hover:bg-gray-700"
      onClick={() => handleChangeLanguage()}
    >
      <img className={`mr-2 w-4 h-4`} src={"img/ic_globe.png"} alt="" />
      <div>{t("lang")}</div>
    </div>
  );
}

LanguageSwitcher.defaultProps = {
  fromMenu: false,
};

export default LanguageSwitcher;
